export const tooltip = {
    bind(el, binding) {
        $(el).tooltip({
            title: binding.value,
            placement: binding.arg,
            trigger: 'hover',
            customClass: 'tooltip-dark',
        })
    },
    update(el, binding) {
    },
    unbind(el) {
        // Destroy the tooltip
        $(el).tooltip('hide');
    }
}

export const tooltipfm = {
    bind(el, binding) {        
        el.mmH =  (e) => {
            window.tooltipfm.textContent = binding.value
            $(window.tooltipfm).css({top: `${e.clientY + 15}px`, left: `${e.clientX + 15}px`, visibility: 'visible', opacity: 1 });
        }
        
        el.mouH = (event) => {
            $(window.tooltipfm).css({visibility: 'hidden', opacity: 0 });
        }

        if(!window.tooltipfm){
            window.tooltipfm = document.createElement("div");
            window.tooltipfm.classList.add("tooltipfm");
            document.body.appendChild(window.tooltipfm);
        }

        el.addEventListener("mousemove", el.mmH);
        el.addEventListener("mouseout", el.mouH);
    },
    update(el, binding) {
    },
    unbind(el) {
        el.removeEventListener("mousemove", el.mmH)
        el.removeEventListener("mouseout", el.mouH)
    }
}

export const popover = {
    bind(el, binding) {
        const options = {
            title: $(el).data('title') || '',
            content: $(el).data('content'),
            placement: $(el).data('placement') || '',
            trigger: $(el).data('trigger') || '',
        }
        console.log(options)
        $(el).popover(options)
    },
    unbind(el) {
        // Destroy the tooltip
        $(el).popover('hide');
    }
}

export const modal = {
    bind(el, binding) {
        el.clickHandler = (ele) => {
            console.warn('modal open event triggered from v-modal directive')
            $($(el).data('target')).modal('show')
        }
        el.addEventListener('click', el.clickHandler)
    },
    unbind(el) {
        console.warn('modal dispose event triggered from v-modal directive')
        el.removeEventListener('click', el.clickHandler)
        $($(el).data('target')).modal('dispose')
    }
}

export const ktMenu = {
    //give it a slight timeout for the child node to fully render
    // setTimeout(() => {
    //     window.KTMenu.createInstances()
    // }, 100)
    bind(el, binding, vnode) {
        let ktx_val = el.getAttribute('ktm-uxid')
        if(!ktx_val){
            ktx_val =  KTUtil.getUniqueId("ktm_")
            el.setAttribute('ktm-uxid', ktx_val)
        }
        // console.log(el, binding, vNode)
        setTimeout(() => {
            // window.KTMenu.createInstances(el)
            // console.warn('X_BIND')
            const ktm = KTMenu.getInstance(el)
            if (!ktm) {
                // console.log("KBD_EXSS")
                window.KTMenu.createInstances(`[ktm-uxid="${ktx_val}"]`)
            }
        }, 100)
    },
    unbind(el) {
        // console.warn('ZX_UNBIND')
        const ktm = KTMenu.getInstance(el)
        if (ktm) {
            ktm.off("kt.menu.dropdown.shown")
            ktm.off("kt.menu.dropdown.hide")
            // console.log(ktm.triggerElement)
            ktm.destroy()
            KTUtil.data(ktm.triggerElement).remove("menu")
        }
    }
}

export default {
    tooltip,
    tooltipfm,
    modal,
    popover,
    ktMenu,
}